exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".breadcrumbs-2o-EO{height:40px;background-color:#e4e7ed;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;padding:0 80px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.breadcrumb-jmk1j{color:#565e85}.separator-19aym{margin:0 10px;top:1px;position:relative}@media(max-width: 1023px){.breadcrumbs-2o-EO{display:none}}.theme-dark .breadcrumbs-2o-EO{background-color:#e4e7ed}.theme-dark .breadcrumb-jmk1j{color:#565e85}.theme-dark .breadcrumb-jmk1j a,.theme-dark .breadcrumb-jmk1j svg{color:#565e85}.theme-light .breadcrumbs-2o-EO{background-color:#507093}.theme-light .breadcrumb-jmk1j{color:#f3f3f3}.theme-light .breadcrumb-jmk1j a,.theme-light .breadcrumb-jmk1j svg{color:#f3f3f3}", ""]);

// exports
exports.locals = {
	"breadcrumbs": "breadcrumbs-2o-EO",
	"breadcrumb": "breadcrumb-jmk1j",
	"separator": "separator-19aym"
};